import React from "react";
import SectorLayout from "@/components/SectorLayout";
import data from "@/data/sectors/logistique";
export default function SecteurLogistique() { return <SectorLayout data={data} />; }
